import { z } from 'zod';
import { lessonsSchema } from './lessons';

export const seriesSchema = z.array(
  z.object({
    documentId: z.string(),
    title: z.nullable(z.string()),
    description: z.nullable(z.string()),
    seasonNumber: z.nullable(z.number()),
    lessons: z.nullable(lessonsSchema),
  }),
);

export type Series = z.infer<typeof seriesSchema>;
